import { render, staticRenderFns } from "./BrandManage.vue?vue&type=template&id=dd590bac&"
import script from "./BrandManage.vue?vue&type=script&lang=js&"
export * from "./BrandManage.vue?vue&type=script&lang=js&"
import style0 from "./BrandManage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports